import React from "react";
import About from "../../components/AboutUs/About";
import Choose from "../../components/AboutUs/Choose";
import Customer from "../../components/AboutUs/Customer";
import Heading from "../../components/AboutUs/Heading";
import Certificate from "../../components/AboutUs/Certificate";
import "./AboutUs.scss";

const AboutUs = () => {
  return (
    <>
      <div id="aboutus">
        <Heading />
        <About />
        <Choose />
        <Customer />
        <Certificate />
      </div>
    </>
  );
};

export default AboutUs;
